module.exports = {
  Days: 'Days',
  Weeks: 'Weeks',
  Months: 'Months',
  CurrentlySelected: '(Currently selected)',
  CurrentPage: '(Current page)',
  NonTicketSettlement: '非都度/月締',
  TicketSettlement: '都度',
  MonthlySettlement: 'Monthly settlement',
  WeeklySettlement: 'Weekly settlement',
  Monthly: 'Monthly',
  Day: 'Day',
  CreditControl: 'Credit control',
  All: 'All',
  PleaseSelectAPartner: 'Please select a partner.',
  InvoiceDate: '請求日',
  BusinessDate: '業務日付',
  BillingDate: 'Billing date',
  CostFinancialDate: 'Cost financial date',
  System: 'System',
  PleaseASpecialApprovalBusiness: 'Please select a special approval business',
  SpecialApprovalSuccessful: 'Special approval successful',
  CancelledSpecialApprovalSuccessful: 'Cancelled special approval Successful',
  OceanShipping: 'Ocean shipping',
  PleaseFillInTheContact: 'Please fill in the contact!',
  Other: 'Other',
  CustomerType: 'Customer type',
  CustomerContactChannel: 'Customer contact channel',
  DueBePrintedOrNeeded: 'Due to credit control exceeding, this ticket has been locked and cannot be printed or EDI. Please contact your superior to unlock it when needed!',
  DearCustomersAssociatedWith: 'Dear, you can only select customers associated with the sale (⊙o⊙)',
  CharacterTooLongPleaseAgain: 'Character length is too long, please maintain again!',
  ShippingTypeCannotBeEmpty: 'Shipping type cannot be empty',
  FullhalfJourneyCannotBeEmpty: 'Full/half journey cannot be empty',
  RouteCannotBeEmpty: 'Route cannot be empty',
  PleaseAPieceOfData: 'Please select a piece of data!',
  OverdueFees: 'Overdue fees',
  OverControllAccountReceivable: 'Overtrust controlled settlement object (accounts receivable)',
  Family: 'Family',
  CRMExpiredTip: 'Dear user, the CRM module you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The CRM module will be restricted from access and data will be retained. After renewal, it can be used again.</div>',
  Barge: 'Barge',
  SalesInquiryListPage: '売上照会リストページ',
  RemoteBookingListPage: 'リモート予約一覧ページ'
}
